<template>
    <b-overlay :show="dataLoaded">
        <b-card>
            <b-button variant="primary" @click="addRole" v-if="$hasPermissions($permissions.EditRoles)">Dodaj pravico</b-button>
            <Table ref="table" class="mt-1" :fields="fields" route="/api/management/v1/role">
                <template #cell(actions)="row">
                    <div class="d-flex justify-content-center">
                        <b-button v-if="!$hasPermissions($permissions.EditRoles)" class="mr-1" @click="editRole(row.item)" ><fa icon="eye"/></b-button>
                        <b-button class="mr-1" variant="warning" @click="editRole(row.item)" v-if="$hasPermissions($permissions.EditRoles)"><fa icon="edit"/></b-button>
                        <b-button @click="deleteRole(row.item.id)" variant="danger" v-if="$hasPermissions($permissions.EditRoles)"><fa icon="trash"/></b-button>
                    </div>
                </template>
            </Table>
        </b-card>
        <RolesModal ref="roleModal" :type="type" v-on:success="getItems()"/>
    </b-overlay>
</template>
<script>
    import RolesModal from '@/views/Admin/Users/Components/RolesModal'
    import Table from '@/views/Components/Table'
    import {BButton, BCard, BOverlay} from 'bootstrap-vue'
    export default {
        components: {
            RolesModal,
            Table,
            BOverlay,
            BCard,
            BButton
        },
        data() {
            return {
                dataLoaded: false,
                role: {title: '', permissions: []},
                type: '',
                fields: [
                    { key: 'title', label: 'Skupina pravic', sortable: true, class: 'text-center' },
                    { key: 'actions', label: '', class: 'text-center' }
                ]
            }
        },
        methods: {
            getItems() {
                setTimeout(function() {
                    this.$refs.table.search()
                }.bind(this), 1000)
            },
            addRole() {
                this.type = 'add'
                this.role = {title: '', permissions: []}
                this.$refs.roleModal.openModal(this.role)
            },
            editRole(role) {
                this.type = 'edit'
                this.role = role
                this.$refs.roleModal.openModal(this.role)
            },
            deleteRole(id) {
                this.$bvModal.msgBoxConfirm('Prosimo potrdite, da želite izbrisati izbrano rolo.', {
                    size: 'sm',
                    okTitle: 'Da',
                    cancelTitle: 'Ne',
                    hideHeaderClose: false,
                    okVariant: 'danger',
                    cancelVariant: 'outline-secondary',
                    centered: true
                }).then(value => {
                    if (value) {
                        const thisIns = this
                        const loadPromise = this.$http.delete(`/api/management/v1/roles/${id}`)
                        loadPromise.then(function() {
                            thisIns.$printSuccess('Rola je izbrisana')
                        }).catch(function(error) {
                            thisIns.$printError(error.response.data)
                        }).finally(function() {
                            thisIns.$refs.table.search()
                        })
                    }
                })
            }
        }
    }
</script>
